// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* src/components/routes/Dashboard/CallsInProgressPanel.css */

.calls-in-progress-panel {
    flex: 0 0 22vh;
    height: 22vh;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    min-height: 0;
    margin: 8px 8px 0;
    border-radius: 8px;
    background: #ffffff;
    box-shadow: 0 10px 24px rgba(54, 76, 99, 0.11);
    border: 1px solid rgba(25, 118, 210, 0.12);
    overflow: hidden;
}

.calls-in-progress-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex: 0 0 auto;
    padding: 6px 12px;
    background: linear-gradient(135deg, #16324f, #1976d2);
    color: #ffffff;
}

.calls-in-progress-header h2 {
    display: flex;
    align-items: center;
    gap: 7px;
    margin: 0;
    font-size: 0.86rem;
    font-weight: 900;
    letter-spacing: 0;
}

.calls-in-progress-header i {
    font-size: 0.8rem;
}

.calls-in-progress-stats {
    display: flex;
    align-items: center;
    gap: 8px;
}

.calls-in-progress-stat {
    display: flex;
    flex-direction: column;
    align-items: center;
    min-width: 58px;
    padding: 3px 10px;
    border-radius: 7px;
    background: rgba(255, 255, 255, 0.14);
}

.calls-in-progress-stat strong {
    font-size: 0.92rem;
    font-weight: 900;
    line-height: 1.1;
}

.calls-in-progress-stat span {
    display: inline-flex;
    align-items: center;
    gap: 3px;
    font-size: 0.6rem;
    font-weight: 800;
    text-transform: uppercase;
    opacity: 0.9;
}

.calls-in-progress-stat--total strong {
    color: #ffffff;
}

.calls-in-progress-stat--inbound {
    background: rgba(76, 201, 240, 0.22);
}

.calls-in-progress-stat--inbound strong {
    color: #c9f2ff;
}

.calls-in-progress-stat--outbound {
    background: rgba(255, 138, 101, 0.22);
}

.calls-in-progress-stat--outbound strong {
    color: #ffe0d2;
}

.calls-in-progress-error {
    flex: 0 0 auto;
    padding: 4px 12px;
    background: #fff1f2;
    color: #b42335;
    font-size: 0.74rem;
    font-weight: 700;
}

.calls-in-progress-list {
    flex: 1 1 auto;
    min-height: 0;
    display: flex;
    align-items: stretch;
    gap: 10px;
    padding: 8px 10px;
    overflow-x: auto;
    overflow-y: hidden;
}

.calls-in-progress-empty {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    width: 100%;
    color: #8a9cab;
    font-size: 0.82rem;
    font-weight: 700;
}

.calls-in-progress-empty i {
    font-size: 1rem;
}

.calls-in-progress-card {
    flex: 0 0 220px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    gap: 8px;
    padding: 12px 14px;
    border-radius: 7px;
    border-left: 4px solid #1e9e5c;
    background: #f3fbf6;
    cursor: pointer;
    position: relative;
    transition: transform 160ms ease, box-shadow 160ms ease;
}

.calls-in-progress-card:hover {
    transform: translateY(-2px);
    box-shadow: 0 8px 18px rgba(36, 52, 71, 0.14);
}

.calls-in-progress-card-top {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 8px;
}

.calls-in-progress-queue {
    color: #16324f;
    font-size: 0.86rem;
    font-weight: 900;
    text-transform: capitalize;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.calls-in-progress-duration {
    flex: 0 0 auto;
    color: #1e9e5c;
    font-size: 0.86rem;
    font-weight: 900;
    font-family: 'Courier New', monospace;
}

.calls-in-progress-card-body {
    display: flex;
    flex-direction: column;
    gap: 4px;
    color: #5d7281;
    font-size: 0.78rem;
    font-weight: 700;
}

.calls-in-progress-card-body span {
    display: flex;
    align-items: center;
    gap: 5px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.calls-in-progress-card-body i {
    flex: 0 0 auto;
    width: 12px;
    color: #8a9cab;
    font-size: 0.68rem;
}

.calls-in-progress-status {
    align-self: flex-start;
    padding: 2px 7px;
    border-radius: 999px;
    font-size: 0.64rem;
    font-weight: 900;
    text-transform: uppercase;
    background: #e8f2ff;
    color: #1d5fa7;
}

.calls-in-progress-status--ringing,
.calls-in-progress-status--queued {
    background: #fff4df;
    color: #a9710a;
}

.calls-in-progress-status--answered,
.calls-in-progress-status--bridged,
.calls-in-progress-status--connected,
.calls-in-progress-status--in-progress {
    background: #e7f8ee;
    color: #1e9e5c;
}

.calls-in-progress-status--outbound,
.calls-in-progress-status--inbound {
    background: #e8f2ff;
    color: #1d5fa7;
}

.calls-in-progress-raw {
    position: absolute;
    top: calc(100% + 4px);
    left: 0;
    z-index: 20;
    width: 320px;
    max-height: 220px;
    overflow: auto;
    margin: 0;
    padding: 8px;
    border-radius: 6px;
    background: #16324f;
    color: #d7e6f5;
    font-size: 0.66rem;
    line-height: 1.4;
    box-shadow: 0 14px 30px rgba(0, 0, 0, 0.26);
}

@media (max-width: 780px) {
    .calls-in-progress-card {
        flex: 0 0 180px;
    }
}

@media (max-width: 560px) {
    .calls-in-progress-header {
        flex-wrap: wrap;
        gap: 6px;
    }

    .calls-in-progress-stat {
        min-width: 48px;
        padding: 2px 7px;
    }
}
`, "",{"version":3,"sources":["webpack://./src/components/routes/Dashboard/CallsInProgressPanel.css"],"names":[],"mappings":"AAAA,6DAA6D;;AAE7D;IACI,cAAc;IACd,YAAY;IACZ,sBAAsB;IACtB,aAAa;IACb,sBAAsB;IACtB,aAAa;IACb,iBAAiB;IACjB,kBAAkB;IAClB,mBAAmB;IACnB,8CAA8C;IAC9C,0CAA0C;IAC1C,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,cAAc;IACd,iBAAiB;IACjB,qDAAqD;IACrD,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,SAAS;IACT,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,qCAAqC;AACzC;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;IACR,iBAAiB;IACjB,gBAAgB;IAChB,yBAAyB;IACzB,YAAY;AAChB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,iBAAiB;IACjB,mBAAmB;IACnB,cAAc;IACd,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,aAAa;IACb,aAAa;IACb,oBAAoB;IACpB,SAAS;IACT,iBAAiB;IACjB,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,QAAQ;IACR,WAAW;IACX,cAAc;IACd,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,QAAQ;IACR,kBAAkB;IAClB,kBAAkB;IAClB,8BAA8B;IAC9B,mBAAmB;IACnB,eAAe;IACf,kBAAkB;IAClB,uDAAuD;AAC3D;;AAEA;IACI,2BAA2B;IAC3B,6CAA6C;AACjD;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,QAAQ;AACZ;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,gBAAgB;IAChB,0BAA0B;IAC1B,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,cAAc;IACd,kBAAkB;IAClB,gBAAgB;IAChB,qCAAqC;AACzC;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,cAAc;IACd,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,WAAW;IACX,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,sBAAsB;IACtB,gBAAgB;IAChB,oBAAoB;IACpB,kBAAkB;IAClB,gBAAgB;IAChB,yBAAyB;IACzB,mBAAmB;IACnB,cAAc;AAClB;;AAEA;;IAEI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;;;;IAII,mBAAmB;IACnB,cAAc;AAClB;;AAEA;;IAEI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,qBAAqB;IACrB,OAAO;IACP,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,cAAc;IACd,SAAS;IACT,YAAY;IACZ,kBAAkB;IAClB,mBAAmB;IACnB,cAAc;IACd,kBAAkB;IAClB,gBAAgB;IAChB,2CAA2C;AAC/C;;AAEA;IACI;QACI,eAAe;IACnB;AACJ;;AAEA;IACI;QACI,eAAe;QACf,QAAQ;IACZ;;IAEA;QACI,eAAe;QACf,gBAAgB;IACpB;AACJ","sourcesContent":["/* src/components/routes/Dashboard/CallsInProgressPanel.css */\n\n.calls-in-progress-panel {\n    flex: 0 0 22vh;\n    height: 22vh;\n    box-sizing: border-box;\n    display: flex;\n    flex-direction: column;\n    min-height: 0;\n    margin: 8px 8px 0;\n    border-radius: 8px;\n    background: #ffffff;\n    box-shadow: 0 10px 24px rgba(54, 76, 99, 0.11);\n    border: 1px solid rgba(25, 118, 210, 0.12);\n    overflow: hidden;\n}\n\n.calls-in-progress-header {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    flex: 0 0 auto;\n    padding: 6px 12px;\n    background: linear-gradient(135deg, #16324f, #1976d2);\n    color: #ffffff;\n}\n\n.calls-in-progress-header h2 {\n    display: flex;\n    align-items: center;\n    gap: 7px;\n    margin: 0;\n    font-size: 0.86rem;\n    font-weight: 900;\n    letter-spacing: 0;\n}\n\n.calls-in-progress-header i {\n    font-size: 0.8rem;\n}\n\n.calls-in-progress-stats {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n}\n\n.calls-in-progress-stat {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    min-width: 58px;\n    padding: 3px 10px;\n    border-radius: 7px;\n    background: rgba(255, 255, 255, 0.14);\n}\n\n.calls-in-progress-stat strong {\n    font-size: 0.92rem;\n    font-weight: 900;\n    line-height: 1.1;\n}\n\n.calls-in-progress-stat span {\n    display: inline-flex;\n    align-items: center;\n    gap: 3px;\n    font-size: 0.6rem;\n    font-weight: 800;\n    text-transform: uppercase;\n    opacity: 0.9;\n}\n\n.calls-in-progress-stat--total strong {\n    color: #ffffff;\n}\n\n.calls-in-progress-stat--inbound {\n    background: rgba(76, 201, 240, 0.22);\n}\n\n.calls-in-progress-stat--inbound strong {\n    color: #c9f2ff;\n}\n\n.calls-in-progress-stat--outbound {\n    background: rgba(255, 138, 101, 0.22);\n}\n\n.calls-in-progress-stat--outbound strong {\n    color: #ffe0d2;\n}\n\n.calls-in-progress-error {\n    flex: 0 0 auto;\n    padding: 4px 12px;\n    background: #fff1f2;\n    color: #b42335;\n    font-size: 0.74rem;\n    font-weight: 700;\n}\n\n.calls-in-progress-list {\n    flex: 1 1 auto;\n    min-height: 0;\n    display: flex;\n    align-items: stretch;\n    gap: 10px;\n    padding: 8px 10px;\n    overflow-x: auto;\n    overflow-y: hidden;\n}\n\n.calls-in-progress-empty {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: 8px;\n    width: 100%;\n    color: #8a9cab;\n    font-size: 0.82rem;\n    font-weight: 700;\n}\n\n.calls-in-progress-empty i {\n    font-size: 1rem;\n}\n\n.calls-in-progress-card {\n    flex: 0 0 220px;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    gap: 8px;\n    padding: 12px 14px;\n    border-radius: 7px;\n    border-left: 4px solid #1e9e5c;\n    background: #f3fbf6;\n    cursor: pointer;\n    position: relative;\n    transition: transform 160ms ease, box-shadow 160ms ease;\n}\n\n.calls-in-progress-card:hover {\n    transform: translateY(-2px);\n    box-shadow: 0 8px 18px rgba(36, 52, 71, 0.14);\n}\n\n.calls-in-progress-card-top {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: 8px;\n}\n\n.calls-in-progress-queue {\n    color: #16324f;\n    font-size: 0.86rem;\n    font-weight: 900;\n    text-transform: capitalize;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n}\n\n.calls-in-progress-duration {\n    flex: 0 0 auto;\n    color: #1e9e5c;\n    font-size: 0.86rem;\n    font-weight: 900;\n    font-family: 'Courier New', monospace;\n}\n\n.calls-in-progress-card-body {\n    display: flex;\n    flex-direction: column;\n    gap: 4px;\n    color: #5d7281;\n    font-size: 0.78rem;\n    font-weight: 700;\n}\n\n.calls-in-progress-card-body span {\n    display: flex;\n    align-items: center;\n    gap: 5px;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n}\n\n.calls-in-progress-card-body i {\n    flex: 0 0 auto;\n    width: 12px;\n    color: #8a9cab;\n    font-size: 0.68rem;\n}\n\n.calls-in-progress-status {\n    align-self: flex-start;\n    padding: 2px 7px;\n    border-radius: 999px;\n    font-size: 0.64rem;\n    font-weight: 900;\n    text-transform: uppercase;\n    background: #e8f2ff;\n    color: #1d5fa7;\n}\n\n.calls-in-progress-status--ringing,\n.calls-in-progress-status--queued {\n    background: #fff4df;\n    color: #a9710a;\n}\n\n.calls-in-progress-status--answered,\n.calls-in-progress-status--bridged,\n.calls-in-progress-status--connected,\n.calls-in-progress-status--in-progress {\n    background: #e7f8ee;\n    color: #1e9e5c;\n}\n\n.calls-in-progress-status--outbound,\n.calls-in-progress-status--inbound {\n    background: #e8f2ff;\n    color: #1d5fa7;\n}\n\n.calls-in-progress-raw {\n    position: absolute;\n    top: calc(100% + 4px);\n    left: 0;\n    z-index: 20;\n    width: 320px;\n    max-height: 220px;\n    overflow: auto;\n    margin: 0;\n    padding: 8px;\n    border-radius: 6px;\n    background: #16324f;\n    color: #d7e6f5;\n    font-size: 0.66rem;\n    line-height: 1.4;\n    box-shadow: 0 14px 30px rgba(0, 0, 0, 0.26);\n}\n\n@media (max-width: 780px) {\n    .calls-in-progress-card {\n        flex: 0 0 180px;\n    }\n}\n\n@media (max-width: 560px) {\n    .calls-in-progress-header {\n        flex-wrap: wrap;\n        gap: 6px;\n    }\n\n    .calls-in-progress-stat {\n        min-width: 48px;\n        padding: 2px 7px;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
